import { useState } from 'react'

import EventBusyIcon from '@mui/icons-material/EventBusy'
import EventRepeatIcon from '@mui/icons-material/EventRepeat'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Grid from '@mui/material/Grid'
import { DatePicker } from '@mui/x-date-pickers'

import { formatDate } from '@util/date-util'

import { StyledError } from '../../../../theme/components/StyledError'
import { useUpdateSubprocesForEntity } from '../../hooks/useUpdateSubprocesForEntity'
import type { Subproces } from '../../types/Subproces'

export { HerplanNetcheck }

interface Props {
  subproces: Subproces
  onClose: () => void
}

const HerplanNetcheck = ({ subproces, onClose }: Props) => {
  const {
    mutate: updateSubprocesForEntity,
    error,
    isPending,
  } = useUpdateSubprocesForEntity()

  const [dueDate, setDueDate] = useState<Date | null>(
    subproces.dueDate ? new Date(subproces.dueDate) : null,
  )

  const onRemovePlanningClick = () => {
    const proces: Partial<Subproces & { text: string }> = {
      _id: subproces._id,
      status: subproces.status,
    }

    const body = {
      entity: subproces.entity,
      subprocesInfo: proces,
    }

    updateSubprocesForEntity(body, { onSuccess: () => onClose() })
  }

  const onSubmitClick = () => {
    const proces: Partial<Subproces & { text: string }> = {
      _id: subproces._id,
      status: subproces.status,
    }

    if (dueDate) {
      proces.dueDate = dueDate.toISOString()
    }

    const body = {
      entity: subproces.entity,
      subprocesInfo: proces,
    }

    updateSubprocesForEntity(body, { onSuccess: () => onClose() })
  }

  return (
    <>
      <DialogContent>
        <StyledError error={error} />

        <Grid container sx={{ width: '100%' }} spacing={1}>
          <Grid size={{ xs: 6 }}>
            <DatePicker
              label="Nieuwe deadline criteria klant verzamelen"
              value={dueDate}
              onChange={setDueDate}
              displayWeekNumber
              disablePast
              slotProps={{
                textField: {
                  variant: 'standard',
                  fullWidth: true,
                },
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Box sx={{ gap: 1, display: 'flex', flexGrow: 1 }}>
          {subproces.dueDate && (
            <Button
              onClick={onRemovePlanningClick}
              color="error"
              variant="outlined"
              startIcon={<EventBusyIcon />}
              disabled={isPending}
            >
              Planning verwijderen
            </Button>
          )}
        </Box>

        <Button color="primary" onClick={onClose} autoFocus>
          Annuleren
        </Button>

        <Button
          onClick={onSubmitClick}
          variant="contained"
          disabled={
            isPending ||
            !dueDate ||
            !!(
              subproces.dueDate &&
              formatDate(dueDate) === formatDate(subproces.dueDate)
            )
          }
          color="primary"
          startIcon={<EventRepeatIcon />}
        >
          Herplannen
        </Button>
      </DialogActions>
    </>
  )
}
